import './view.scss';

//console.log('Frontend Script');
